/*
 * CART-OFFERS 2026-09-27: one-tap add for snippets/ervp-cart-offers.liquid.
 * Delegated from the document because the cart drawer and cart page are
 * re-rendered in place after every cart change.
 */
(function() {
  if (window.ervpCartOffersReady) return;
  window.ervpCartOffersReady = true;

  document.addEventListener('click', function(event) {
    var button = event.target.closest('[data-ervp-cart-offer-add]');
    if (!button || button.disabled) return;
    event.preventDefault();
    event.stopPropagation();

    var root = button.closest('[data-ervp-cart-offers]');
    var error = root && root.querySelector('.ervp-cart-offers__error');
    var addUrl = (window.routes && window.routes.cartAddUrl) || '/cart/add';
    button.disabled = true;
    if (error) error.hidden = true;
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    fetch(addUrl + '.js', {
      body: JSON.stringify({ items: [{ id: parseInt(button.getAttribute('data-ervp-cart-offer-add'), 10), quantity: 1 }] }),
      credentials: 'same-origin',
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function(response) {
      return response.json().then(function(result) {
        if (!response.ok) throw new Error(result.description || result.message || '');
        if (!window.theme || window.theme.cartType === 'page') {
          window.location.href = (window.routes && window.routes.cartUrl) || '/cart';
          return;
        }
        // The theme re-renders the drawer or the cart page and keeps the item count right.
        document.documentElement.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: { variant: null, quantity: 1 }
        }));
      });
    }).catch(function(reason) {
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
      button.disabled = false;
      if (error) {
        error.textContent = (reason && reason.message) || 'This item could not be added. Please add it from its product page.';
        error.hidden = false;
      }
    });
  }, true);
})();
